import { useTranslation } from 'react-i18next';
import TypeCustomSelect from '../../../form/form-fields/TypeCustomSelect';

export const MatchingPropLeadFieldSelect = ({ property, onChange }) => {
  const { t } = useTranslation();

  const valueField = {
    label: property.label,
    key: 'minValue',
    options: property.options || [],
    noUnselect: true,
  };

  function handleUpdate(key, value) {
    const newProp = { ...property, [key]: value };
    onChange(newProp);
  }

  return (
    <TypeCustomSelect
      size="small"
      field={valueField}
      dataCollection={property}
      startDataCollection={property}
      updateValidationOnChange={handleUpdate}
    />
  );
};
